import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=48df54be&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=48df54be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df54be",
  null
  
)

export default component.exports